import { resolvePublicAssetUrl } from '@/utils/resolvePublicAssetUrl'
import type { BlocoAttachment } from '@/types/bloco'

interface BlocoAttachmentsListProps {
  attachments: BlocoAttachment[]
  compact?: boolean
}

export function BlocoAttachmentsList({ attachments, compact = false }: BlocoAttachmentsListProps) {
  if (!attachments.length) return null

  return (
    <div className={compact ? 'flex flex-wrap gap-1.5' : 'grid gap-2 sm:grid-cols-2'}>
      {attachments.map((attachment) => {
        const url = resolvePublicAssetUrl(attachment.fileUrl)
        const isImage = attachment.mimeType.startsWith('image/')

        return (
          <a
            key={attachment.id}
            href={url}
            target='_blank'
            rel='noopener noreferrer'
            className={
              compact
                ? 'inline-flex items-center gap-1 rounded-md bg-[var(--glass-bg)] px-2 py-0.5 text-[11px] font-medium text-[var(--brand-primary)] hover:underline'
                : 'group block overflow-hidden rounded-lg border border-[var(--glass-border)] bg-bg-card transition-colors hover:border-[var(--brand-primary)]/40'
            }
          >
            {compact ? (
              <span className='truncate max-w-[140px]'>{attachment.fileName}</span>
            ) : isImage ? (
              <img
                src={url}
                alt={attachment.fileName}
                className='h-28 w-full object-cover object-top'
              />
            ) : (
              <div className='flex h-20 items-center justify-center px-3 text-xs font-medium text-text-primary'>
                PDF · {attachment.fileName}
              </div>
            )}
            {!compact && (
              <div className='truncate px-2 py-1.5 text-xs text-text-muted group-hover:text-text-primary'>
                {attachment.fileName}
              </div>
            )}
          </a>
        )
      })}
    </div>
  )
}
